export default __webpack_public_path__ + "static/media/logotipo-composicion.7fcac869.png";